import PropTypes from "prop-types";
import * as React from "react";
import { CartProduct } from "../../../domain";
import { Button, Dialog } from "../../../themeV2";
import CartProductEditor from "../../CartProductEditor";
import useCartProductEditor from "../../CartProductEditor/useCartProductEditor";
import css from "./EditDialog.module.css";

const EditDialog = React.memo(function EditDialog({ cartProduct, onClose }) {
  const editor = useCartProductEditor(cartProduct);
  const [open, setOpen] = React.useState(true);

  const handleSubmit = async (evt) => {
    evt.preventDefault();
    if (await editor.save()) {
      setOpen(false);
    }
  };

  return (
    <Dialog.Root
      open={open}
      onOpenChange={setOpen}
      onOpenChangeComplete={(isOpen) => {
        if (!isOpen) onClose();
      }}
    >
      <Dialog.Popup size="md" fullScreenOnCompact>
        <Dialog.Title>Edit &mdash; {cartProduct.name}</Dialog.Title>

        <form className={css.form} onSubmit={handleSubmit}>
          <Dialog.Body>
            <CartProductEditor cartProduct={cartProduct} editor={editor} />
          </Dialog.Body>

          <Dialog.Actions>
            <Button variant="text" onClick={() => setOpen(false)}>
              Cancel
            </Button>
            <Button type="submit">Update</Button>
          </Dialog.Actions>
        </form>
      </Dialog.Popup>
    </Dialog.Root>
  );
});

EditDialog.propTypes = {
  cartProduct: PropTypes.instanceOf(CartProduct).isRequired,
  onClose: PropTypes.func.isRequired,
};

export default EditDialog;
